import React from "react";
import MYGAStrings from "../../../Resources/Content/MYGAStrings";
import pages from "../../../scripts/myga-ui";
import "./AppCompleted.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Resources from "../../../Resources/Resources";
import AppContentWrapper from "../AppContentWrapper/AppContentWrapper";
import {NassauLog} from "../../../scripts/myga-utils"
import GENERATOR from "../../../selenium-front-end/generator/Generator";
import {PAGES} from "../../../scripts/constants";

class AppCompleted extends React.Component {
    
    constructor(props) {
        super(props);
        // setup default prev/next pages with props overrides
        // this.nextPage = props.nextPage || PAGES.pageDashboard; // 2021.07.15.ADivelbiss - commented in favor of PageManager getNextPage solution
    }

    onNextPressed = async () => {
        if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
            // if the test mode is running then stop the test at this point.
            await GENERATOR.disableAfterNextCommit();
        }
    }
    
    render() {

        return (
    
            <AppContentWrapper
                nextLabel={MYGAStrings.AppCompleted_ButtonForwardLabel}
                onNextPressed={this.onNextPressed}
                updatePage={this.props.updatePage}>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div id={pages.app_completed.html.text_completed_message}
                             className={"font-page-regular"}>
                            {MYGAStrings.AppCompleted_CompletedMessage}
                        </div>
                    </div>
                </div>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.EnvelopeOpenText}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_receive_email_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppCompleted_ReceiveEmailAndSignLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_receive_email_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppCompleted_ReceiveEmailAndSign}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.Search}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_review_application_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppCompleted_ReviewApplicationLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_review_application_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppCompleted_ReviewApplication}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.DollarSign}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_making_payment_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppCompleted_MakingPaymentLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_making_payment_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppCompleted_MakingPayment}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div className={"col-2 app-completed-icons"}>
                            <FontAwesomeIcon icon={Resources.Icons.FileContract}/>
                        </div>
                        <div className={"col-10"}>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_have_contract_label}
                                     className={"page-section-title"}>
                                    {MYGAStrings.AppCompleted_HaveContractInHandLabel}
                                </div>
                            </div>
                            <div className={"row"}>
                                <div id={pages.app_completed.html.text_have_contract_message}
                                     className={"font-page-regular"}>
                                    {MYGAStrings.AppCompleted_HaveContractInHand}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div className={"container page-section"}>
                    <div className={"row"}>
                        <div id={pages.app_completed.html.text_fine_print}
                             className={"page-fine-print"}>
                            {MYGAStrings.AppCompleted_FinePrint}
                        </div>
                    </div>
                </div>
    
            </AppContentWrapper>
            
        );

    }
}

export default AppCompleted;